import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Box, FormControl, FormHelperText, InputLabel, Select, selectClasses, styled } from '@mui/material';
import { Icon } from '@elements/icon';
import { colors, pxToRem } from '@themes';
var StyledFormControl = styled(FormControl)(function (_ref) {
  var fullWidth = _ref.fullWidth;
  var styles = {
    display: fullWidth && 'flex',
    maxWidth: '100%'
  };
  return styles;
});
var StyledInputLabel = styled(InputLabel)(function (_ref2) {
  var theme = _ref2.theme;
  var styles = {
    position: 'relative',
    transform: 'unset',
    transformOrigin: 'unset',
    maxWidth: '100%',
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(24),
    color: theme.colors.comet,
    display: 'block',
    whiteSpace: 'unset',
    '&.Mui-focused': {
      color: theme.colors.comet
    }
  };
  return styles;
});
var StyleFormHelperWrapper = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  var styles = {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '100%',
    marginTop: theme.typography.pxToRem(4),
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(14),
    zIndex: 1
  };
  return styles;
});
var StyledFormHelperErrorText = styled(FormHelperText)(function (_ref4) {
  var theme = _ref4.theme;
  var styles = {
    color: theme.colors.bitterSweet,
    display: 'block',
    padding: theme.spacing(0, 2),
    margin: 'unset',
    maxWidth: '100%'
  };
  return styles;
});
var StyledFormHelperText = styled(FormHelperText)(function (_ref5) {
  var theme = _ref5.theme;
  var styles = {
    color: theme.colors.raven,
    display: 'block',
    padding: theme.spacing(0, 2),
    maxWidth: '100%',
    fontSize: pxToRem(13),
    fontWeight: 400,
    lineHeight: pxToRem(18),
    margin: '0 auto',
    textAlign: 'center'
  };
  return styles;
});
var StyledSelect = styled(Select, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isApplied' && prop !== 'basicSelect';
  }
})(function (_ref6) {
  var _styles;

  var theme = _ref6.theme,
      isApplied = _ref6.isApplied,
      basicSelect = _ref6.basicSelect;
  var styles = (_styles = {
    border: 'none',
    borderRadius: pxToRem(14),
    overflow: 'hidden'
  }, _defineProperty(_styles, "& .".concat(selectClasses.multiple), {
    paddingRight: 0
  }), _defineProperty(_styles, "& .".concat(selectClasses.select), {
    boxSizing: 'border-box',
    height: theme.typography.pxToRem(48),
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(20),
    fontWeight: 500,
    letterSpacing: '-0.003em',
    color: basicSelect ? theme.colors.mineShaft : isApplied ? theme.colors.white : theme.colors.mineShaft,
    padding: "".concat(theme.spacing(1.75, 6.25, 1.75, 2), " !important"),
    position: 'relative',
    backgroundColor: basicSelect ? theme.colors.whisper : isApplied ? theme.colors.funGreen : theme.colors.whisper
  }), _defineProperty(_styles, '&.Mui-disabled', {
    '& .MuiSelect-icon': {
      display: 'none'
    }
  }), _defineProperty(_styles, '& .MuiOutlinedInput-notchedOutline', {
    border: 'none'
  }), _styles);
  return styles;
});
var StyledSelectIcon = styled(Icon, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isClose';
  }
})(function (_ref7) {
  var theme = _ref7.theme,
      height = _ref7.height,
      isClose = _ref7.isClose;
  var styles = {
    position: 'absolute',
    right: pxToRem(16),
    top: "calc(50% - ".concat(pxToRem(height / 2), ")"),
    display: 'flex',
    pointerEvents: isClose ? 'all' : 'none',
    cursor: 'pointer',
    zIndex: 1,
    transition: theme.transitions.create(['transform'])
  };
  return styles;
});

var SelectPaperStyles = function SelectPaperStyles(theme) {
  return {
    transform: 'translateY(8px)',
    borderRadius: pxToRem(14)
  };
};

var SelectMenuStyles = function SelectMenuStyles(theme) {
  return {
    paddingTop: theme === null || theme === void 0 ? void 0 : theme.spacing(1),
    paddingBottom: theme === null || theme === void 0 ? void 0 : theme.spacing(1),
    li: {
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(0.75, 1.5),
      fontWeight: 400,
      fontSize: pxToRem(14),
      lineHeight: pxToRem(20),
      color: colors.comet,
      '&:hover': {
        backgroundColor: colors.lightFunGreen
      },
      ':last-child': {
        marginBottom: theme === null || theme === void 0 ? void 0 : theme.spacing(0)
      },
      '&.Mui-selected': {
        backgroundColor: 'transparent'
      },
      '&.Mui-selected:hover': {
        backgroundColor: 'transparent'
      }
    }
  };
};

export { SelectMenuStyles, SelectPaperStyles, StyledFormControl, StyledFormHelperErrorText, StyledFormHelperText, StyledInputLabel, StyledSelect, StyledSelectIcon, StyleFormHelperWrapper };